import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import fileImg from 'Images/generic_file.svg';
import { FormattedMessage } from 'react-intl';
import {
  Wrapper,
  SummaryContainer,
  Icon,
  File,
  Filenames,
  SubText,
  ErrorText
} from './styled';

class UploadSummary extends React.Component {
  constructor (props) {
    super(props);
    this.state = {};
  }

  render () {
    const { files, errorFilesList, transactional } = this.props;
    const subText = transactional ? 'file_upload_modal.file_uploaded' : 'file_upload_modal.processing';
    return (
      <Wrapper>
        <SummaryContainer>
          <Icon><File src={ fileImg } alt="File" /></Icon>
          <Filenames>
            { files.map((f) => (errorFilesList.indexOf(f.name) === -1 ? <div>{f.name}</div> : <ErrorText>{f.name}</ErrorText>)) }
          </Filenames>
          <SubText>
            <FormattedMessage id={ subText } />
          </SubText>
        </SummaryContainer>
      </Wrapper>

    );
  }
}

UploadSummary.propTypes = {
  files: PropTypes.array.isRequired,
  errorFilesList: PropTypes.array.isRequired
};

const mapDispatchToProps = () => ({

});

const mapStateToProps = () => ({

});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(UploadSummary));
